import {useDraggable, useDroppable} from '@dnd-kit/core';
import {SeatSlotWithPosition} from '../types';
import {FABRIC_DEFAULTS} from '../utils/fabric-defaults';

interface Props {
    slot: SeatSlotWithPosition;
    cx: number;
    cy: number;
    editMode: boolean;
    isOver: boolean;
    isDragging: boolean;
    displayNumber: number;
}

const TableSettingsSeatPriorityDraggable: React.FC<Props> = ({
                                                                 slot,
                                                                 cx,
                                                                 cy,
                                                                 editMode,
                                                                 isOver,
                                                                 isDragging,
                                                                 displayNumber,
                                                             }) => {
    const {attributes, listeners, setNodeRef: setDragRef} = useDraggable({
        id: slot.id,
        disabled: !editMode,
    });

    const {setNodeRef: setDropRef, isOver: isDropOver} = useDroppable({
        id: slot.id,
        disabled: !editMode,
    });

    const isHighlighted = isOver || isDropOver;

    let fill = FABRIC_DEFAULTS.seat.fillActive;
    let stroke = FABRIC_DEFAULTS.seat.strokeActive;
    let strokeWidth = 2;
    let radius = 11;

    if (isHighlighted && !isDragging) {
        fill = '#1976d2';
        stroke = '#1565c0';
        strokeWidth = 3;
        radius = 14;
    }

    return (
        <g
            ref={(node) => {
                setDragRef(node as unknown as HTMLElement);
                setDropRef(node as unknown as HTMLElement);
            }}
            {...(editMode ? {...attributes, ...listeners} : {})}
            style={{
                cursor: editMode ? (isDragging ? 'grabbing' : 'grab') : 'default',
                touchAction: editMode ? 'none' : undefined,
                outline: 'none',
                opacity: isDragging ? 0.3 : 1,
                transition: 'opacity 200ms ease',
            }}
            tabIndex={editMode ? 0 : -1}
            pointerEvents="all"
        >
            <circle
                cx={cx}
                cy={cy}
                r={radius}
                fill={fill}
                stroke={stroke}
                strokeWidth={strokeWidth}
                style={{transition: 'r 150ms ease, fill 150ms ease, stroke 150ms ease'}}
            />
            <text
                x={cx}
                y={cy}
                textAnchor="middle"
                dominantBaseline="central"
                fontSize={10}
                fontWeight="bold"
                fill="#fff"
                style={{pointerEvents: 'none', userSelect: 'none'}}
            >
                {displayNumber}
            </text>
        </g>
    );
};

export default TableSettingsSeatPriorityDraggable;
